module.exports = __webpack_public_path__ + "assets/img/37_1492.9d72c13f.jpg";